<style lang="scss" scoped>
// @import 'common/sass/reuse.SCSS';
.handle {
  margin: 25px;
  .addBtn {
    margin-left: 20px;
  }
  .handle-row {
    width: 100%;
  }
  .empty {
    padding: 20px;
  }
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 10px;
  width: 50%;
}
.el-select {
  width: 100%;
}
/deep/ .el-drawer__body {
  overflow-y: auto;
}

.description{
    height: 40px;
    line-height: 40px;
    font-size: 15px;
  }
</style>

<template>
  <div class="maintenance-box">
    <div class="panel">
      <el-row class="handle">
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="addBtn">
          <el-button type="primary" class="handle-row" icon="el-icon-circle-plus" @click="openConfigWindow">{{ language.addBtnTxt }}</el-button>
        </el-col>
      </el-row>
      <el-row v-loading="configLoading">
        <el-table :data="confListPaging" border>
          <template v-for="(v, i) in language.accHead">
            <el-table-column :label="v.value" :key="i">
              <template slot-scope="scope">
                <el-input v-if="v.writable" type="textarea" maxlength="255" v-model="scope.row[v.key]"></el-input>
                <span v-else>{{ scope.row[v.key] }}</span>
              </template>
            </el-table-column>
          </template>
          <el-table-column :label="language.lastTableColumnTxt" width="120px">
            <template slot-scope="scope">
              <el-button type="danger" icon="el-icon-delete" circle @click="deleteChargeDividendsConfig(scope.row.symbol)"></el-button>
              <el-button v-show="scope.row.status == 0" type="primary" icon="el-icon-edit" circle @click="updateConfig(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row class="handle">
        <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
          <div class="empty"></div>
        </el-col>
        <el-col :lg="9" :md="9" :sm="9" :xl="9" :xs="9">
          <el-pagination
            :current-page="pageNum"
            :page-size="pageSize"
            :page-sizes="[5, 10, 25, 50]"
            :pager-count="5"
            :total="total"
            @current-change="handlePageChange"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
    <!-- add config window -->
    <el-dialog :title="language.addDialogTitle" :visible.sync="configWindow" :before-close="(done) => {}" :show-close="false">
      <el-form :model="confForm" :rules="rules" ref="confForm" label-position="top">
        <el-form-item :label="language.addSymbolTxt" prop="symbol">
            <el-select v-model="confForm.symbol" filterable :placeholder="language.formSelectDefaultTxt">
                <el-option 
                    v-for="item in symbolList" 
                    :disabled="disabledSymbols.includes(item.SYMBOL)"
                    :key="item.SYMBOL" 
                    :label="item.SYMBOL" 
                    :value="item.SYMBOL"
                >
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item :label="language.addBuyTxt" prop="buy">
            <el-input v-model="confForm.buy"></el-input>
        </el-form-item>
        <el-form-item :label="language.addSellTxt" prop="sell">
            <el-input v-model="confForm.sell"></el-input>
        </el-form-item>
        <el-form-item :label="language.addGroupTxt" prop="group">
            <el-input v-model="confForm.group"></el-input>
        </el-form-item>
        <el-form-item :label="language.addZipTxt" prop="zipcode">
            <el-input v-model="confForm.zipcode"></el-input>
        </el-form-item>
        <el-form-item :label="language.addCommentTxt" prop="comment">
            <el-input v-model="confForm.comment"></el-input>
        </el-form-item>
        <el-form-item :label="language.addExcuteTimeTxt" prop="excuteTime">
            <el-input v-model="confForm.excuteTime"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetFilledConfig">{{ language.formCancelTxt }}</el-button>
        <el-button type="primary" @click="addChargeDividendsConfig">{{ language.formConfirmTxt }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { 
    URL_SYMBOL_LIST,
    URL_ADDORUPDATE_DIVIDENDS_CONFIG,
    URL_DELETE_DIVIDENDS_CONFIG,
    URL_GET_DIVIDENDS_CONFIG
} from 'api/api'
const data = () => {
    return {
        confListPaging: [],
        confList: [],
        configLoading: false,
        configWindow: false,
        confForm: {
            symbol: null,
            group: null,
            zipcode: null,
            buy: null,
            sell: null,
            excuteTime: null,
            comment: null,
        },
        symbolList: [],
        updateSymbol: null,
        disabledSymbols: [],

        pageNum: 1,
        pageSize: 5,
        total: 0,
    }
}

const mixins = [
    require('common/mixin/base').base({ language: 'chargeDividends' }), 
    require('common/mixin/base').base({ reuse: 'reuse' })
]

const computed = {
    tableHead() {
        return this.language.tableHead
    },
    rules() {
        const language = this.language;
        const buyOrSellRegexp = new RegExp(/^-?[0-9]+([.]{1}[0-9]+){0,1} ([a-zA-Z]{3}|pt)$/);
        const timeRegexp = new RegExp(/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2]\d|3[0-1]) ([0-1]\d|2[0-3]):([0-5]\d):([0-5]\d)$/);
        const rules = {
            symbol: [
                { 
                    required: true, 
                    validator: (rule, value, callback) => {
                        if(!value) callback(language.symbolRulesRequired)
                        else callback()
                    }, 
                    trigger: 'change' 
                },
            ],
            buy: [
                this.regexpRule(buyOrSellRegexp, language.buyRulesRequired, language.buyOrSellRulesInvalid)
            ],
            sell: [
                this.regexpRule(buyOrSellRegexp, language.sellRulesRequired, language.buyOrSellRulesInvalid)
            ],
            group: [
                this.requiredRule(language.groupRulesRequired),
            ],
            zipcode: [
                this.requiredRule(language.zipcodeRulesRequired),
            ],
            comment: [
                this.requiredRule(language.commentRulesRequired),
            ],
            excuteTime: [
                this.regexpRule(timeRegexp, language.excuteTimeRulesRequired, language.timeRulesInvalid)
            ]
        }
        return rules
    },
}

const created = function () {
    this.$http.get(URL_SYMBOL_LIST).then(res => this.symbolList = res.data.data)
    this.getChargeDividendsConfig()
}

const methods = {
    addChargeDividendsConfig() {
        this.$refs['confForm'].validate((valid) => {
            if (valid) {
                const modifyBy = JSON.parse(sessionStorage.getItem('user') || '{}').name
                const addObj = {
                    modifyBy, 
                    ...this.confForm
                }
                const isAdd = this.updateSymbol != addObj.symbol
                const successKey = isAdd ? 'addSuccess' : 'updateSuccess'
                const failedKey = isAdd ? 'addFailed' : 'updateFailed'

                this.$http.post(URL_ADDORUPDATE_DIVIDENDS_CONFIG, addObj).then((res) => {
                    const code = res.data.data
                    if (code === 9000) this.$message({ message: this.language[successKey], type: 'success' })
                    else this.$message({ message: this.language[failedKey], type: 'error' })
                    this.getChargeDividendsConfig()
                    this.resetFilledConfig()
                })
            }
        })
    },
    getChargeDividendsConfig() {
        this.configLoading = true
        this.disabledSymbols = []
        this.$http.get(URL_GET_DIVIDENDS_CONFIG).then((res) => {
            const result = res.data.data
            this.confList = result
            this.confList.forEach(conf => {
                this.disabledSymbols.push(conf.symbol)
                conf.statusDesc = this.language.statusMapping[conf.status]
            })
            this.total = result.length
            this.slicData()
            this.configLoading = false
        })
    },
    updateConfig(row) {
        const symbol = row.symbol
        const updateObj = { symbol, buy: row.buy, sell: row.sell, group: row.group, zipcode: row.zipcode, comment: row.comment, excuteTime: row.excute_time}
        this.configWindow = true
        this.$nextTick(function(){
            Object.assign(this.confForm, updateObj)
            this.updateSymbol = symbol
        })
    },
    deleteChargeDividendsConfig(symbol) {
        const lg = this.language
        this.$confirm(`${lg.deleteMsgTxt}`, lg.notifyTxt, { confirmButtonText: lg.formConfirmTxt, cancelButtonText: lg.formCancelTxt, type: 'warning' }).then(() => {
            this.$http.delete(URL_DELETE_DIVIDENDS_CONFIG, { params: { symbol } }).then((res) => {
                const code = res.data.data
                if (code == 9000) {
                    this.$message({ message: lg.delSuccess, type: 'success' })
                    // 第N页删除后页码需要减一
                    const countAfterDelete = this.total - 1
                    if(countAfterDelete % this.pageSize === 0) this.pageNum -= countAfterDelete / this.pageSize
                    this.getChargeDividendsConfig()
                } else {
                    this.$message({ message: lg.delFailed, type: 'info' })
                }
            })
        })
    },
    openConfigWindow() {
        this.configWindow = true
        this.$refs['confForm'].resetFields()
    },
    resetFilledConfig() {
        this.configWindow = false
        this.updateSymbol = null
    },
    handlePageChange(val) {
        this.pageNum = val
        this.slicData()
    },
    handleSizeChange(val) {
        this.pageNum = 1
        this.pageSize = val
        this.confListPaging = this.confList.slice(0, this.pageSize)
    },
    slicData() {
        this.confListPaging = this.confList.slice((this.pageNum - 1) * this.pageSize, this.pageNum * this.pageSize);
    },
    requiredRule(message) {
        return { required: true, message, trigger: 'blur' };
    },
    numberRule(message) {
        const numberRule = {
            type: 'number',  
            validator: (rule, value, callback) => {
                if(value > 0) callback()
                else callback(message)
            }, 
            trigger: 'blur'
        };
        return numberRule;
    },
    regexpRule(regExp, requiredMsg, invalidMsg) {
        const regexpRule = {
            required: true,
            validator: (rule, value, callback) => {
                if(value) {
                    regExp.test(value) ? callback() : callback(invalidMsg)
                    return;
                } else callback(requiredMsg)
            }, 
            trigger: 'blur'
        };
        return regexpRule;
    }
}

const watch = {
  language() {
    this.confListPaging.forEach(conf => {
        conf.statusDesc = this.language.statusMapping[conf.status]
    })
  }
}

export default {
    data,
    mixins,
    computed,
    created,
    methods,
    watch,
}
</script>


// WEBPACK FOOTER //
// src/views/report/charge-dividends.vue